import {useDispatch, useSelector} from 'react-redux'
import {getIncentiveProcessWorker} from './store'
import React, {useEffect, useState} from 'react'

import {DataGrid, trTR} from '@mui/x-data-grid'
import Pagination from '@mui/material/Pagination'
import PaginationItem from '@mui/material/PaginationItem'
import {
    Select,
    MenuItem,
    Card,
    Typography,
    CircularProgress,
    Box,
    IconButton
} from '@mui/material'

import PropTypes from 'prop-types'

import {BsFileImage} from 'react-icons/bs'

function CircularProgressWithLabel(props) {
    return (
        <Box sx={{position: 'relative', display: 'inline-flex'}}>
            <CircularProgress variant="determinate" {...props} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary">
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    )
}

CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     * @default 0
     */
    value: PropTypes.number.isRequired
}

const download = (row) => {
    const link = document.createElement('a')
    link.setAttribute('href', row)
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
    link.setAttribute('download', row.split('/')[-1])
    link.click()
}

const columns = [
    {
        field: 'order',
        headerName: 'Sıra',
        minWidth: 100,
        sortable: false,
        flex: 1,
        filterable: false
    },
    {
        field: 'identificationNumber',
        headerName: 'Kimlik No',
        minWidth: 200,
        sortable: false,
        flex: 1,
        filterable: false
    },
    {
        field: 'name',
        headerName: 'İsim Soyisim',
        minWidth: 200,
        sortable: false,
        flex: 1,
        filterable: false
    },
    {
        field: 'incentiveProcessWorkerStatus',
        headerName: 'Durum',
        minWidth: 200,
        sortable: false,
        flex: 1,
        filterable: false
    },
    {
        field: 'pageImage',
        headerName: 'Detay Sayfa',
        minWidth: 100,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => (
            <>
                {params.row.pageImage !== null && params.row.pageImage !== "" ? <IconButton size='60' onClick={() => download(params.row.pageImage)}>
                    <BsFileImage size={30}/>
                </IconButton> : null}
            </>
        )
    },
    {
        field: 'image1',
        headerName: 'Tanımlama 1',
        minWidth: 100,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => (
            <>
                {params.row.image1 !== null && params.row.image1 !== "" ? <IconButton size='60' onClick={() => download(params.row.image1)}>
                    <BsFileImage size={30}/>
                </IconButton> : null}
            </>
        )
    },
    {
        field: 'image2',
        headerName: 'Tanımlama 2',
        minWidth: 100,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => (
            <>
                {params.row.image2 !== null && params.row.image2 !== "" ? <IconButton size='60' onClick={() => download(params.row.image2)}>
                    <BsFileImage size={30}/>
                </IconButton> : null}
            </>
        )
    }
]

function CustomPagination(props) {
    const handlePageSizeChange = (event) => {
        props.onPageSizeChange(event.target.value)
    }

    const handlePageChange = (event, newPage) => {
        props.onPageChange(newPage - 1)
    }
    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
            <Select
                value={props.pageSize}
                onChange={handlePageSizeChange}
                style={{marginRight: '16px', marginTop: '-10px'}}
            >
                {props.pageSizeOptions.map((size) => (
                    <MenuItem key={size} value={size}>
                        {size}
                    </MenuItem>
                ))}
            </Select>
            <Pagination
                color='primary'
                shape='circular'
                page={props.page + 1}
                count={props.rowCount}
                renderItem={(props2) => <PaginationItem {...props2} disableRipple/>}
                onChange={handlePageChange}
            />
        </div>
    )
}

const ProcessWorker = ({data}) => {
    const dispatch = useDispatch()
    const store = useSelector(state => state.incentiveManagement)
    const authStore = useSelector(state => state.auth)

    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(25)
    const [searchTerm, setSearchTerm] = useState([])
    // const [sort, setSort] = useState('desc')
    // const [sortColumn, setSortColumn] = useState('id')
    //
    // const handleSortModelChange = React.useCallback((sortModel) => {
    //     // Here you save the data you need from the sort model
    //     // if (sortModel.length > 0) {
    //     //     setSortColumn(sortModel[0].field)
    //     //     setSort(sortModel[0].sort)
    //     // } else {
    //     //     setSortColumn('id')
    //     //     setSort('desc')
    //     // }
    // }, [])


    const getDataParameter = () => {
        return {
            page: page + 1,
            pageSize,
            // sort,
            // sortColumn,
            searchTerm,
            id: data
        }
    }


    const handleFilter = val => {
        setSearchTerm(val.items)
    }

    useEffect(() => {
        dispatch(getIncentiveProcessWorker(getDataParameter()))
    }, [dispatch, authStore.selectedCompanyGroup, page, pageSize, searchTerm])

    useEffect(() => {
        dispatch(getIncentiveProcessWorker(getDataParameter()))

    }, [])

    return (
        <>
            <Card>
                <div style={{height: 540, width: '100%'}}>
                    <DataGrid
                        rows={store.workerProcessData}
                        columns={columns}
                        rowCount={store.workerProcessTotal}
                        pageSize={pageSize}
                        paginationMode="server"
                        sortingMode='server'
                        filterMode='server'
                        onFilterModelChange={handleFilter}
                        // onSortModelChange={handleSortModelChange}
                        onPageChange={(params) => {
                            setPage(params.page)
                        }}
                        onPageSizeChange={(params) => {
                            setPageSize(params.pageSize)
                        }}
                        pageSizeOptions={[5, 10, 25]}
                        slots={{
                            pagination: () => <CustomPagination
                                page={page}
                                pageSize={pageSize}
                                rowCount={store.workerProcessTotal}
                                pageSizeOptions={[5, 10, 25]}
                                onPageChange={(newPage) => {
                                    setPage(newPage)
                                }}
                                onPageSizeChange={(newPageSize) => {
                                    setPageSize(newPageSize)
                                }}
                            />
                        }}
                        localeText={trTR.components.MuiDataGrid.defaultProps.localeText}
                    />
                </div>
            </Card>
        </>
    )
}

export default ProcessWorker
